import { HeartHandshake } from "lucide-react";
import { GMB_URL, CALL_URL, PHONE_DISPLAY, WHATSAPP_URL } from "./ContactButtons";

export const Footer = () => (
  <footer data-testid="site-footer" className="overflow-hidden border-t border-white/5 bg-[#080809]">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-24 md:px-10">
      <p
        data-testid="footer-giant-brand"
        className="giant-outline select-none whitespace-nowrap font-serif text-[14vw] leading-none tracking-tight xl:text-[12rem]"
        aria-hidden="true"
      >
        PIPEWALAS
      </p>

      <div className="mt-16 flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <p className="font-serif text-2xl tracking-[0.15em] text-[#F5F5F0]">PIPEWALAS</p>
          <p className="mt-1.5 text-[10px] font-semibold tracking-[0.4em] text-[#C5A059]">
            HOUSE &amp; HOMESTAYS
          </p>
          <p data-testid="footer-address" className="mt-3 max-w-sm text-sm leading-relaxed text-[#A1A1AA]">
            CK21/35-37, Thatheri Bazar, Govindpura, Varanasi, Uttar Pradesh 221001
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#C5A059]/30 px-4 py-1.5 text-xs text-[#C5A059]">
            <HeartHandshake className="h-3.5 w-3.5" />
            LGBTQ+ friendly · All travellers welcome
          </div>
        </div>

        <div className="flex flex-col items-start gap-2 text-sm text-[#A1A1AA] md:items-end">
          <a
            data-testid="footer-phone-link"
            href={CALL_URL}
            className="font-semibold text-[#F5F5F0] transition-colors hover:text-[#C5A059]"
          >
            {PHONE_DISPLAY}
          </a>
          <a
            data-testid="footer-whatsapp-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-[#C5A059]"
          >
            WhatsApp the house
          </a>
          <a
            data-testid="footer-gmb-link"
            href={GMB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-[#C5A059]"
          >
            Google Business Profile
          </a>
          <a href="#top" data-testid="footer-top-link" className="transition-colors hover:text-[#C5A059]">
            Back to the ghats ↑
          </a>
          <p className="mt-4 text-xs text-[#A1A1AA]/60">
            © {new Date().getFullYear()} Pipewalas House &amp; Homestays, Varanasi
          </p>
        </div>
      </div>
    </div>
  </footer>
);
